<template>
  <LegacyCollectionPage
    v-if="isLegacy"
    :page-mode="pageMode"
  />

  <div v-else>
    <splitter-banner
      v-if="showTopBanner"
      :page-mode="category"
    />

    <content-loop
      v-if="rows && rows.length"
      :rows="rows"
    />
  </div>
</template>

<script>
import collectionQuery from '~/gql/collection.gql'

export const legacyPageMapping = {
  '/shop/parts/pace': 'paceparts',
  '/shop/cases': 'cases',
  '/shop/lenses': 'lenskits',
  '/shop/parts': 'goggleparts'
}

/* prettier-ignore */
const categories = {
  all: {
    products: ['classics3', 'renegades', 'sierras', 'tempests', 'tokas', 'zephyrs', 'miras', 'vulcans-ff', 'airas-zf', 'velans-tf', 'ultras', 'gts', 'vanguards', 'ullrs', 'snipers']
  },
  accessories: {
    products: ['classics3', 'renegades', 'sierras', 'tempests', 'tokas', 'zephyrs', 'miras', 'vulcans-ff', 'airas-zf', 'velans-tf', 'ultras', 'gts', 'vanguards', 'ullrs', 'snipers']
  },
  sunglasses: {
    products: ['classics3', 'renegades', 'sierras', 'tempests', 'tokas', 'zephyrs', 'miras', 'vulcans-ff', 'airas-zf', 'velans-tf', 'ultras', 'gts']
  },
  lifestyle: {
    products: ['classics3', 'renegades', 'sierras', 'tempests', 'tokas', 'zephyrs', 'miras']
  },
  pace: {
    products: ['vulcans-tf', 'velans-tf', 'vulcans-ff', 'velans-ff', 'airas-zf', 'airas-bf', 'ultras', 'gts', 'tempests']
  },
  goggles: {
    products: ['vanguards', 'ullrs', 'snipers']
  }
}

export default defineNuxtComponent({
  async setup() {
    definePageMeta({
      pageType: 'Product Landing Page',
    })

    const route = useRouter().currentRoute.value
    const { $head, $i18n, $sentry, runWithContext } = useNuxtApp()
    
    const pathWithoutLocale = route.path.replace(`/${$i18n.locale.value}`, '')
    if (pathWithoutLocale in legacyPageMapping) {
      return {
        isLegacy: true,
        pageMode: legacyPageMapping[pathWithoutLocale],
      }
    }

    const rows = ref([])
    const showTopBanner = ref(false)
    const slug = route.params.category
    const { data: collectionResponse, error } = await useDatoQuery({
      query: collectionQuery,
      variables: {
        slug,
      },
    })

    if (error.value) {
      $sentry.captureException(error)
    }

    if (!collectionResponse.value?.collection) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Not Found',
        fatal: true
      })
    }

    const category = computed(() => {
      return route.params.category
    })

    const products = computed(() => {
      return categories[category.value]?.products || []
    })

    const collection = collectionResponse.value.collection
    if (collection) {
      rows.value = collection.rows || []
      showTopBanner.value = collection.showTopBanner ?? showTopBanner.value
    }
    
    runWithContext(() => useHead($head(collection.meta)))

    return {
      isLegacy: false,
      rows,
      showTopBanner,
      products,
      category
    }
  },

  data: () => ({
    categories,
  }),
})
</script>
